module.exports = __webpack_public_path__ + "static/media/f.5896a616.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/f.mp3
// module id = 95
// module chunks = 0